import React from 'react';
import { Button } from '@material-ui/core';
import Close from '@material-ui/icons/Close';

const { Fragment } = React;

export const getSnack = p => (text, options, button) =>
  p.enqueueSnackbar(text, {
    ...options,
    action: key => (
      <Fragment>
        {button && (
          <Button
            href={button.url}
            target="_blank"
            rel="noreferrer noopener"
            variant="outlined"
            style={{
              borderColor: 'white',
              borderRadius: 20,
              color: 'white',
              fontSize: '0.9em',
              textTransform: 'none',
            }}
          >
            {button.text}
          </Button>
        )}
        <Button
          onClick={() => {
            p.closeSnackbar(key);
          }}
          style={{
            color: 'inherit',
          }}
        >
          <Close />
        </Button>
      </Fragment>
    ),
  });
